/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleUpIcon24Regular = forwardRef('ArrowFigureACircleUpIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 17.25a.75.75 0 0 1-.75-.75V8.81l-2.72 2.72a.75.75 0 0 1-1.06-1.06l3.005-3.006a2.156 2.156 0 0 1 3.05 0l3.005 3.006a.75.75 0 1 1-1.06 1.06l-2.72-2.72v7.69a.75.75 0 0 1-.75.75Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 21.75c-5.385 0-9.75-4.365-9.75-9.75S6.615 2.25 12 2.25s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75ZM3.75 12a8.25 8.25 0 1 0 16.5 0 8.25 8.25 0 0 0-16.5 0Z" })));
});
